/* eslint-disable sonarjs/no-clear-text-protocols */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import { Button } from '@els/els-react--button';
import { dispatchOpenRemoteAccessDialog } from '@Containers/RemoteAccess/RemoteAccessDialogActions';
import Catalyst from '@Services/Catalyst';

import './Footer.scss';

const currentYear = new Date().getFullYear();

export default function Footer(props) {
  const { className } = props;
  const [footerLogoUrl, setFooterLogoUrl] = useState('http://www.elsevier.com/?dgcid=RN_AGCM_Sourced_300005028');
  const [termsAndConditionsUrl, setTermsAndConditionsUrl] = useState(
    'http://www.elsevier.com/legal/elsevier-website-terms-and-conditions?dgcid=RN_AGCM_Sourced_300005028'
  );
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('http://www.elsevier.com/legal/privacy-policy?dgcid=RN_AGCM_Sourced_300005028');
  const contactSupportUrl = 'https://service.elsevier.com/app/contact/supporthub/reaxys/';
  const accessibilityUrl = 'https://service.elsevier.com/app/answers/detail/a_id/38528/supporthub/reaxys/';
  const remoteAccessLinkClick = (e) => {
    e.preventDefault();
    dispatchOpenRemoteAccessDialog();
  };

  const contactSupportLinkClick = () => {
    // AA
    Catalyst.trackLinkOut(null, {
      location: 'footer',
      name: 'Contact Support',
      type: 'exit',
      destination: 'https://service.elsevier.com/app/contact/supporthub/reaxys/',
    });
  };
  useEffect(() => {
    async function updateFooterUrls() {
      const updatedLogoUrl = await Catalyst.appendVisitorIDToUrl(footerLogoUrl);
      const updatedTermsAndConditionsUrl = await Catalyst.appendVisitorIDToUrl(termsAndConditionsUrl);
      const updatedPrivacyPolicyUrl = await Catalyst.appendVisitorIDToUrl(privacyPolicyUrl);
      setFooterLogoUrl(updatedLogoUrl);
      setTermsAndConditionsUrl(updatedTermsAndConditionsUrl);
      setPrivacyPolicyUrl(updatedPrivacyPolicyUrl);
    }
    updateFooterUrls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <footer
      className={classnames(className, 'rx-footer rx-left-gutter rx-right-gutter')}
      aria-label="About Reaxys"
      role="contentinfo"
      id="footer">
      <div className="rx-footer__logo-elsevier-wrapper">
        <a href={footerLogoUrl} target="_blank" className="link-image">
          <span className="screen-reader-text">Elsevier</span>
          <svg className="rx-footer__logo-elsevier">
            <use xlinkHref="#logo-non-solus" />
          </svg>
        </a>
      </div>

      <div className="rx-footer--links">
        <div className="rx-footer--links__row">
          <ul className="rx-footer--links__list">
            <li>
              <Button
                type="link"
                className="els-document-link remote-access-link e2e-footer-remote-access-link footer-link"
                onClick={(e) => {
                  remoteAccessLinkClick(e);
                }}>
                Remote access
              </Button>
            </li>
            <li>
              <LinkElement
                className="els-document-link footer-link"
                href={termsAndConditionsUrl}
                a11y={{ name: 'Terms and conditions' }}
                isExternal
                noExternalIcon>
                Terms and Conditions
              </LinkElement>
            </li>
            <li>
              <LinkElement
                className="els-document-link footer-link"
                href={privacyPolicyUrl}
                a11y={{ name: 'Privacy policy' }}
                isExternal
                noExternalIcon>
                Privacy policy
              </LinkElement>
            </li>
            <li>
              <LinkElement
                className="els-document-link footer-link"
                href="/#/about-content"
                a11y={{ name: 'About content' }}
                isExternal
                noExternalIcon>
                About content
              </LinkElement>
            </li>
            <li>
              <LinkElement
                className="els-document-link footer-link"
                href={accessibilityUrl}
                a11y={{ name: 'Accessibility' }}
                isExternal
                noExternalIcon>
                Accessibility
              </LinkElement>
            </li>
            <li>
              <LinkElement
                className="els-document-link footer-link"
                href={contactSupportUrl}
                a11y={{ name: 'Contact support' }}
                isExternal
                onClick={() => {
                  contactSupportLinkClick();
                }}
                noExternalIcon>
                Contact support
              </LinkElement>
            </li>
          </ul>
        </div>

        <div className="rx-footer--links__row">
          <span className="rx-footer--links__desc">We use cookies to help provide and enhance our service and tailor content.&nbsp;</span>
          {/* OneTrust Cookies Settings button start */}
          <button type="button" id="ot-sdk-btn" className="ot-sdk-show-settings">
            Cookie Settings
          </button>
          {/* OneTrust Cookies Settings button end */}
        </div>

        <div className="rx-footer--links__row">
          <span className="rx-footer--links__copyright">
            {}
            All content on this site: Copyright &copy; {currentYear} Elsevier B.V., its licensors, and contributors. All rights are
            reserved, including those for text and data mining, AI training, and similar technologies. For all open access content, the
            relevant licensing terms apply.
          </span>
        </div>
      </div>
      <div className="rx-footer__logo-relx-wrapper">
        <a href="http://www.relx.com/" target="_blank" className="link-image">
          <span className="screen-reader-text">RELX™</span>
          <svg className="rx-footer__logo-relx">
            <use xlinkHref="#logo-relx" />
          </svg>
        </a>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  className: PropTypes.string,
};
